var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.init
    ? _c(
        "div",
        { staticClass: "_component-floating-toolbar" },
        [
          _vm.showLoginModal
            ? _c("LoginModal", {
                attrs: { initState: _vm.loginModalType, modal: true },
                on: {
                  close: function($event) {
                    _vm.showLoginModal = false
                  }
                }
              })
            : _vm._e(),
          _c("SideHelperMobile"),
          _vm.isShowUserDropdown
            ? _c("UserDropdown", {
                on: { select: _vm.handleSelect },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trigger",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "user-info" },
                            [
                              _c("SvgIcon", {
                                attrs: { name: "icon-user", color: "#fff" }
                              })
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3582381486
                )
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }